import { COLOR_TYPE, ColorItmes } from '@/types/PromotionType'

export const colorItems: ColorItmes[] = [
  {
    color: COLOR_TYPE.red,
    variant: 'blossom',
    name: '紅區'
  },
  {
    color: COLOR_TYPE.green,
    variant: 'shamrock',
    name: '綠區'
  },
  {
    color: COLOR_TYPE.blue,
    variant: 'lake',
    name: '藍區'
  }
]
